define('views/ecards/passkit',[
    'backbone',
    'views/_base/baseview',
    'text!views/ecards/passkit.html',
    'models/ecard/ecard_detail',
    'views/shared/modal/modal_modern',
    'views/shared/alerts/alert',
    'models/ecard/balance',
    'models/ecard/status',
    'models/ecard/pass',
    'views/ecards/pass',
    'models/ecard/ecard_detail'
], function(Backbone, BaseView, Template, GiftCardModel, Modal, AlertModalView, EcardBalanceModel, EcardStatusModel, EcardPassModel, PasskitView, EcardDetailModel){
    'use strict';

    return BaseView.extend({
        className: 'passkit-container',
        tagName  : 'div',
        isRender : true,
        template : _.template(Template),
        events   : {
            'click .js-passkit-back-btn'     : 'goBackMODAL',
            'click .js-passkit-check-balance': 'showCurrentBalanceMODAL',
            'click .js-passkit-remove-ecard' : 'deleteCurrentCardMODAL',
            'click #pf-modal-close-btn'      : 'removeDeleteMODAL',
            'click .js-passkit-print-ecard'  : 'printEcardMODAL'
        },
        initialize: function(options){
            options = options || {};

            this.active_giftcard = 0;
            this.giftcard_count = 0;
            this.giftcard_width = 327;

            this.data = options.data;
            this.gcguid = (options.gcguid) ? options.gcguid : options.data.gcguid;
            this.header = options.header;
            this.wallet = options.wallet;
            this.merchant = options.merchant;
            this.self_contained = options.self_contained;
            this.parent_view_MODAL = options.parent_view_MODAL;
            this.calling_view_MODAL = options.calling_view_MODAL;

            this.remove_giftcard_alert_modal_view = null;

            this.elementName = options.elementName;

            BaseView.prototype.initialize(this);
        },

        render: function(){
            var that = this;

            this.$el.html(this.template());
            
        },

        loadData: function(){
            var that = this,
                ecards = [];

            for(var i = 0; i < this.data.ecards.length; i++){
                ecards.push(this.data.ecards[i]);
            }

            this.loadEcardPasskit(ecards);

        },

        loadEcardPasskit: function(ecards){
            var that = this;

            if(ecards[0]){
                var ecard = ecards[0];

                that.giftcard_pass_model = new EcardPassModel({ giftcard_guid: ecard.GiftCardGUID });
                that.giftcard_pass_model.fetch({
                    success: function(model, resp){

                        if(resp && resp.data){
                            var data = atob(resp.data);

                            var pass_json = JSON.parse(data.slice(data.indexOf('pass.json') + 9, data.indexOf('formatVersion') + 17));

                            that.giftcard_count = that.giftcard_count + 1;

                            that.showPass(pass_json, ecard);
                        } else {
                            that.giftcard_count = that.giftcard_count + 1;
                            that.showActivationSpot(ecard);
                        }

                        // Remove the current ecard
                        ecards.splice(0,1);

                        // Load the next ecard passkit
                        that.loadEcardPasskit(ecards);
                        

                    },
                    error: function(err){
                        that.giftcard_count = that.giftcard_count + 1;
                        that.showActivationSpot(ecard);

                        // Remove the current ecard
                        ecards.splice(0,1);

                        // Load the next ecard passkit
                        that.loadEcardPasskit(ecards);
                    }
                });

            } else {

                // Update the pagination to show the correct selected passkit
                that.updatePagination();

                // Add pagination event handler
                that.addPaginationEvent();

                // Show pagination
                that.showPagination();

                setTimeout(function(){

                    if(that.data.ecards && that.data.ecards.length >= 1){

                        // Show the selected passkit
                        that.showActiveGiftCard();

                        // Detect scrolling through passkit list
                        $('.js-passkit-slider').on('scroll',function(e){
                            that.scrollGiftCard(e);
                        });

                    }

                }, 1500);

            }


        },

        showPagination: function(){
            $('.js-passkit-slider-pagination-loader-container').hide();
            $('.js-passkit-slider-pagination').show();
        },

        scrollGiftCard: function(e){
            var position = $(e.target).scrollLeft(),
                unrounded_index = position / this.giftcard_width,
                index = Math.round(unrounded_index);
            
            this.active_giftcard = index;
            this.updatePagination();
            this.updateBalanceCheck();
        },

        showActiveGiftCard: function(){
            var left_position = this.active_giftcard * this.giftcard_width;

            $('.js-passkit-slider').scrollLeft(left_position);
            this.updateBalanceCheck();
        },

        showPass: function(pass_data, ecard){
            var pass = new PasskitView({ data: pass_data, ecard: ecard });

            if(ecard.GiftCardGUID == this.gcguid){
                // Deduct by one because we are incrementing the giftcard_count before we show the pass
                this.active_giftcard = this.giftcard_count - 1;
            }

            $('.js-passkit-slider-list').css({ width: (this.giftcard_count * this.giftcard_width) + 'px' });

            $('.js-passkit-slider-list').append(pass.el);

            this.addPagination();

            if(this.calling_view_MODAL && this.calling_view_MODAL.merchantGroupInfoView){
                this.agid = this.calling_view_MODAL.merchantGroupInfoView.merchant.AggregatorID;
            } else if(this.merchant){
                this.agid = this.merchant.AggregatorID;
            }

            this.updatePrintBtn();

            this.addPasskitDescription();
        },

        updatePrintBtn: function(){            

            if(enums.aggregatorID.Print == this.agid){
                $('.js-passkit-print-ecard').show();
            }

        },

        addPasskitDescription: function(){

            if(enums.aggregatorID.Print == this.agid){
                $('.js-passkit-description').html('Print out this eGift Card and bring it with you to the store.');
            } else {
                $('.js-passkit-description').html('This eGift Card can be presented in-store or entered in the gift card field online.');
            }

        },

        showActivationSpot: function(ecard){
            var that = this;

            var activation_spot_model = new EcardDetailModel({ GCGUID: ecard.GiftCardGUID });

            activation_spot_model.fetch({
                success: function(model, resp){
                    var data = activation_spot_model.toJSON(),
                        list_view = document.createElement('li'),
                        iframe = document.createElement('iframe'),
                        host = (data.ActivationSpotURL) ? data.ActivationSpotURL : 'https://egift.activationspot.com/egift.aspx',
                        eid = data.VirtualGiftCardId,
                        tid = data.TenantId,
                        url = host+'?eid='+eid+'&tid='+tid+'&gcm=n&gs=n&gw=n&print=n';

                    iframe.src = url;
                    iframe.onload = function(){
                        $(list_view).find('.pass-loading').fadeOut().remove();
                    };

                    list_view.className = 'pass-container';

                    $(list_view).html('<div class="pass-loading">'+enums.svg.loadingIcon+'</div><div class="pass-activation-spot"></div>');

                    $(list_view).find('.pass-activation-spot').append(iframe);

                    if(ecard.GiftCardGUID == that.gcguid){
                        that.active_giftcard = that.giftcard_count;
                    }

                    $('.js-passkit-slider-list').css({ width: (that.giftcard_count * that.giftcard_width) + 'px' });

                    $('.js-passkit-slider-list').append(list_view);

                    that.addPagination();
                    that.updatePrintBtn();
                },
                error: function(err){}
            });

        },

        printEcardMODAL: function(){
            var that = (this.data) ? this : this.calling_view,
                ecard_found = false;

            that.data.ecards.forEach(function(ecard, index){

                if(that.active_giftcard == index){

                    that.activation_spot_model = new EcardDetailModel({ GCGUID: ecard.GiftCardGUID });
                    that.activation_spot_model.fetch({
                        success: function(model, resp){
                            var data = that.activation_spot_model.toJSON(),
                                host = (data.ActivationSpotURL) ? data.ActivationSpotURL : 'https://egift.activationspot.com/egift.aspx',
                                eid = data.VirtualGiftCardId,
                                tid = data.TenantId,
                                url = host+'?eid='+eid+'&tid='+tid+'&gcm=n&gs=n&gw=n&print=y';

                            var print_window = window.open(url, '_blank');
                        },
                        error: function(err){
                            pfdialog.alert({
                                Title     : 'Oops!',
                                Body      : 'Looks like something went wrong, please try again later.',
                                okCallback: function(){}
                            });
                        }
                    });

                }

            });

            if(!ecard_found){
                console.log('ecard was not found, display message');
            }
        },

        updateBalanceCheck: function(balance){
            var that = (this.data) ? this : this.calling_view,
                ecard_found = false,
                check_balance_btn = $('.js-passkit-check-balance'),
                check_balance_number = $('.js-passkit-giftcard-balance');

            that.data.ecards.forEach(function(ecard, index){

                if(that.active_giftcard == index){

                    ecard_found = true;

                    if(ecard.BalanceInquiryStatus && !balance){

                        check_balance_number.hide();
                        check_balance_number.html('<span class="passkit-giftcard-balance-loader js-passkit-giftcard-balance-loader">' + enums.svg.loadingIcon + '</span>');
                        check_balance_btn.show();
                        check_balance_btn.html('Check Balance');
                        check_balance_btn.prop('disabled',false);

                    } else if(_.isNumber(balance)){

                        check_balance_btn.hide();
                        check_balance_number.html(formatBalanceCurrency(balance));
                        check_balance_number.fadeIn();

                    }

                }

            });

            if(!ecard_found){
                // console.log('updateBalanceCheck not found');

                check_balance_number.hide();
                check_balance_number.html('<span class="passkit-giftcard-balance-loader js-passkit-giftcard-balance-loader">' + enums.svg.loadingIcon + '</span>');
                check_balance_btn.show();
                check_balance_btn.html('Check Balance Unavailable');
                check_balance_btn.prop('disabled',true);
            }

        },

        updatePagination: function(){

            $('.js-passkit-slider-pagination').find('li').removeClass('active');

            $('.js-passkit-slider-pagination').find('li').eq(this.active_giftcard).addClass('active');

        },

        addPagination: function(){

            $('.js-passkit-slider-pagination').append('<li><a href="#" class="js-pagination-item">&#160;</a></li>');

            this.addPaginationEvent();

        },

        addPaginationEvent: function(){
            var that = this;

            $('.js-pagination-item').on('click',function(e){
                if(e && e.preventDefault){ e.preventDefault(); }
                if(e && e.stopPropagation){ e.stopPropagation(); }

                that.active_giftcard = $(e.target).parent().index();

                that.showActiveGiftCard();

                that.updatePagination();
            });

        },

        hideLoader: function(){
            // console.log('hideLoader');
        },

        goBackMODAL: function(){

            this.closeMODAL();

            // if(this.wallet){

            //     this.ecard_group_slider_view = new EcardGroupSliderView({
            //         data          : this.merchant,
            //         wallet        : this.wallet,
            //         header        : this.header,
            //         merchant      : merchant,
            //         self_contained: true,
            //         calling_view_MODAL: this
            //     });
                    
            //     var ecard_modal = new Modal({
            //         show        : true, // True, if we want the modal to show itself when it's ready
            //         content     : this.ecard_group_slider_view.$el.html(),
            //         calling_view: this // Send in corresponding view to inherit events and custom properties
            //     });

            // } else {
            //     // Just close the modal
            //     this.closeMODAL();
            // }

        },

        deleteCurrentCardMODAL: function(){

            this.remove_giftcard_alert_modal_view = new AlertModalView({
                // General
                calling_view       : this,
                alert_type         : 1,
                // Transactional
                is_transaction     : false,
                // Content
                alert_header       : 'Delete eGift Card',
                alert_message      : 'Are you sure you want to delete this eGift Card? This cannot be undone.',
                // Default
                btn_label          : 'Delete',
                btn_color          : 'red',
                btn_callback       : this.removeGiftCardMODAL,
                btn_retry_callback : this.removeGiftCardMODAL,
                // Confirm
                btn_confirm        : false,
                // Cancel
                btn_cancel         : true,
                btn_cancel_label   : 'Cancel',
                btn_cancel_callback: this.cancelRemoveGiftCardMODAL,
                // Success
                btn_success        : true,
                btn_success_delay  : 700,
                btn_success_label  : 'OK',
                btn_success_message: 'Successfully removed the eCard',
                btn_success_callback: this.removeGiftCardSuccessMODAL,
                // Error
                btn_error          : true,
                btn_error_delay    : 700,
                btn_error_label    : 'Retry',
                btn_error_cancel_label: 'Cancel',
                btn_error_message  : 'Please try again.',
                btn_error_callback : this.canceledRemoveGiftCardOnErrorMODAL
            });

            this.alert_modal = new Modal({
                show        : true,
                content     : this.remove_giftcard_alert_modal_view.$el.html(),
                calling_view: this.remove_giftcard_alert_modal_view
            });

        },

        removeDeleteMODAL: function(){
            var that = this;
            // console.log('removeDeleteMODAL',this);

            this.alert_modal.$el.fadeOut(function(){
                that.alert_modal.$el.remove();
            });
        },

        removeGiftCardMODAL: function(processComplete, that){
            var ecard_found = false;

            if(!that){
                var that = (this.data) ? this : this.calling_view;
            } else {
                that = (that.data) ? that : that.calling_view;
            }

            // Temporary fix for THIS switch
            if(that.remove_giftcard_alert_modal_view){
                var remove_giftcard_alert_modal_view = that.remove_giftcard_alert_modal_view;
            } else {
                var remove_giftcard_alert_modal_view = this.remove_giftcard_alert_modal_view;
            }

            that.data.ecards.forEach(function(ecard, index){

                if(that.active_giftcard == index){

                    ecard_found = true;

                    that.ecard_status_model = new EcardStatusModel({
                        status_id    : enums.ecardStatusID.redeemed,
                        giftcard_guid: ecard.GiftCardGUID
                    });
                    
                    that.ecard_status_model.save(null, {
                        success: function(response){
                            
                            if(processComplete.name){
                                remove_giftcard_alert_modal_view[processComplete.name](true);
                            } else {
                                processComplete(true, remove_giftcard_alert_modal_view);
                            }
                            
                        },
                        error  : function(err){
                            // console.log('ecard status error',err,that.ecard_status_model);

                            that.cannot_delete_ecard_alert_modal_view = new AlertModalView({
                                // General
                                calling_view       : that,
                                alert_type         : 1,
                                // Transactional
                                is_transaction     : false,
                                // Content
                                alert_header       : 'Unable to remove eCard',
                                alert_message      : 'We are unable to remove eCard.',
                                // Default
                                btn_label          : 'OK',
                                btn_callback       : that.cannotDeleteEcardMODAL,
                                btn_retry_callback : that.cannotDeleteEcardMODAL,
                                // Confirm
                                btn_confirm        : false,
                                // Cancel
                                btn_cancel         : false,
                                // Success
                                btn_success        : false,
                                // Error
                                btn_error          : false
                            });

                            that.cannot_delete_alert_modal = new Modal({
                                show        : true,
                                content     : that.cannot_delete_ecard_alert_modal_view.$el.html(),
                                calling_view: that.cannot_delete_ecard_alert_modal_view
                            });

                        }
                    });

                }

            });
        },

        cannotDeleteEcardMODAL: function(processComplete, that){
            var that = (that) ? that : this;

            that.removeDeleteMODAL();

            that.cannot_delete_alert_modal.$el.fadeOut(function(){
                that.cannot_delete_alert_modal.$el.remove();
            });

        },

        cancelRemoveGiftCardMODAL: function(that){
            var that = (that) ? that : this;

            that.removeDeleteMODAL();

        },

        removeGiftCardSuccessMODAL: function(resetButtons, that){
            var that = (that) ? that : this,
                remaining_ecards = [];

            that.remove_giftcard_alert_modal_view[resetButtons.name]();

            that.calling_view.data.ecards.forEach(function(ecard, index){

                if(ecard.GiftCardGUID != that.calling_view.gcguid){
                    remaining_ecards.push(ecard);
                }

            });

            that.calling_view.data.ecards = remaining_ecards;

            $('.js-passkit-slider-list').css({ width: '0px' });
            $('.js-passkit-slider-list').html('');
            $('.js-passkit-slider-pagination').html('');

            that.calling_view.giftcard_count = 0;

            that.calling_view.loadData();

            pf.globalEvents.trigger('reload_ecard_groups', remaining_ecards);

            if(_.isObject(this.parent_view_MODAL) && _.isFunction(this.parent_view_MODAL.loadData)){

                this.parent_view_MODAL.loadData();

            }

            if(_.isObject(this.calling_view_MODAL)){

                if(_.isFunction(this.calling_view_MODAL.loadEcards)){

                    // this.calling_view_MODAL.loadEcards(null, this.calling_view_MODAL.wallet_view);

                }

            }

        },

        canceledRemoveGiftCardOnErrorMODAL: function(that){
            // console.log('canceledRemoveGiftCardOnErrorMODAL',e);
        },

        showCurrentBalanceMODAL: function(){
            var that = (this.data) ? this : this.calling_view,
                ecard_found = false;

            that.data.ecards.forEach(function(ecard, index){

                if(that.active_giftcard == index){

                    var check_balance_btn = $('.js-passkit-check-balance'),
                        check_balance_number = $('.js-passkit-giftcard-balance');

                    ecard_found = true;

                    check_balance_btn.prop('disabled',true);
                    check_balance_btn.hide();

                    check_balance_number.fadeIn();

                    that.ecard_balance_model = new EcardBalanceModel({
                        user_guid    : pf.session.get('UserGUID'),
                        giftcard_guid: ecard.GiftCardGUID
                    });
                    
                    that.ecard_balance_model.fetch({
                        success: function(response){
                            var data = that.ecard_balance_model.toJSON();

                            if(!data.has_error){
                                that.updateBalanceCheck(data.balance);
                            } else {

                            }
                            
                        },
                        error  : function(err){
                            // console.log('ecard balance error',err,that.ecard_balance_model, that.ecard_balance_model.toJSON());

                            check_balance_number.hide();

                            check_balance_btn.prop('disabled',false);
                            check_balance_btn.fadeIn();

                            that.balance_error_alert_modal_view = new AlertModalView({
                                // General
                                calling_view       : that,
                                alert_type         : 1,
                                // Transactional
                                is_transaction     : false,
                                // Content
                                alert_header       : 'Not available',
                                alert_message      : 'Balance check not available for this eCard.',
                                // Default
                                btn_label          : 'OK',
                                btn_callback       : that.balanceCheckErrorMODAL,
                                btn_retry_callback : that.balanceCheckErrorMODAL,
                                // Confirm
                                btn_confirm        : false,
                                // Cancel
                                btn_cancel         : false,
                                // Success
                                btn_success        : false,
                                // Error
                                btn_error          : false
                            });

                            that.balance_error_alert_modal = new Modal({
                                show        : true,
                                content     : that.balance_error_alert_modal_view.$el.html(),
                                calling_view: that.balance_error_alert_modal_view
                            });
                        }
                    });

                }

            });

            if(!ecard_found){
                console.log('ecard was not found, display message');
            }

        },

        balanceCheckErrorMODAL: function(processComplete, that){
            var that = (that) ? that : this;

            that.balance_error_alert_modal.$el.fadeOut(function(){
                that.balance_error_alert_modal.$el.remove();
            });

        },

        closeMODAL: function(){

            var pf_modal = this.$el;

            if(pf_modal.is('#pf-modal-modern')){

                pf_modal.fadeOut(function(){
                    pf_modal.remove();
                });

            } else {

                $('#pf-modal-modern').fadeOut(function(){
                    $('#pf-modal-modern').remove();
                });

            }
            
        },

        close: function(){}
    });
});
